import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Comatose } from 'components/helpers/utils';

import '../styles/zapcash-banner.less';

export default class ZapCashBanner extends React.Component {
  static propTypes = {
    balance: PropTypes.number,
    className: PropTypes.string,
    id: PropTypes.string,
    currency: PropTypes.string
  };

  render() {
    let balance = this.props.balance ? this.props.balance : 0;
    let zapcashClass = classNames([
      { hide: balance === null || balance < 1 },
      this.props.className
    ]);

    let balanceClass = classNames([{ zap: this.props.id === '1' }, 'balance']);

    let logo =
      this.props.id === '1' ? (
        <img src={require('../images/zapcash.svg')} />
      ) : null;

    let label =
      this.props.id === '1'
        ? 'Use your ZAPCash at stores with this sign on the door.'
        : 'Use your ' + this.props.currency + ' at these stores.';

    let balanceLabel =
      this.props.id === '1'
        ? Comatose(balance)
        : Comatose(balance) + ' ' + this.props.currency;
    return (
      <div id="zapcash-banner" className={zapcashClass}>
        <div className="zapcash-balance-container">
          {logo}
          <div className={balanceClass}>{balanceLabel}</div>
        </div>
        {label}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/widgets/ZapCashBanner.js